import { parseOnlyNumericValue, removeUnderScrSpCharSpaceBet, sliceText } from "../../../utils/common";
import { removeMultipleSpace, safeString } from "../../../utils/logger";

export const EPF_INITIAL_STATE={

  epfOrganizationIsDisabled:true,
  epfOrganizationNumber: "",
  epfOrganizationStatus: "",
  epfOrganizationCoverageDate: "",
  epfOrganizationEmployeeContribution: "",
  epfOrganizationEmployerContribution:"",
  epfOrganizationOffice: "",
  epfOrganizationAddress: "",
  epfOrganizationCity: "",
  epfOrganizationState:"",
  epfOrganizationCountry:1,
  epfOrganizationPinCode: "",
  epfOrganizationLocation: "",
  epfOrganizationMaster1:false,
  epfOrganizationMaster2:false,
  epfOrganizationMaster3:false,
  epfOrganizationMaster4:false,
}
const today = new Date().toISOString().split('T')[0];
const houndredYearsAgo = new Date();
houndredYearsAgo.setFullYear(houndredYearsAgo.getFullYear() - 100);
export const EPF_INPUT_FIELDS = {
  epfOrganizationNumber: {
    name: "epfOrganizationNumber",
  required:true,
    fullWidth: true,
 
    label:"EPF Number",
    placeholder:"Type Here...",
    type:"text",

    customOptions: {
      formatValueFn: (value) => sliceText(removeUnderScrSpCharSpaceBet(safeString(value).toUpperCase()), 22),
    },
  },
  epfOrganizationCoverageDate: {
    name: "epfOrganizationCoverageDate",

  
    fullWidth: true,

    type:"date",
   
    label:"Coverage Date",
    placeholder:"Type Here...",
    max:today,
  
    required:true,

    
    
  },
  epfOrganizationEmployeeContribution: {
    name: "epfOrganizationEmployeeContribution",
   
    placeholder: "Type Here...",
    type: "select",

    fullWidth: true,

  required:true,
   
    label:"Employee Contribution",
    options:[
      {
        id: "restrict_contribution",
        name: "Restrict Contribution To ₹15000 Of PF Wages",
      },
      {
        id: "unrestricted_contribution",
        name: "Unrestricted Contribution (Based on Actual Wages)",
      },
    ],
  },
  epfOrganizationEmployerContribution: {
    name: "epfOrganizationEmployerContribution",
   
    placeholder: "Type Here...",
   
    fullWidth: true,
    required:true,


    type: "select",
  
    label:"Employer Contribution",
    options:[
      {
        id: "restrict_contribution",
        name: "Restrict Contribution To ₹15000 Of PF Wages",
      },
      {
        id: "unrestricted_contribution",
        name: "Unrestricted Contribution (Based on Actual Wages)",
      },
    ],
  },
  epfOrganizationStatus: {
    name: "epfOrganizationStatus",
  
    placeholder: "Type Here...",
  
    fullWidth: true,
    type: "select",
    required: true,



 
    label:"EPF Status",
    options:[
      { id: "12%", name: "Unexempted 12%" },
      { id: "10%", name: "Exempted 10%" },
    ],
  },
  under_epf_office: {
    name: "under_epf_office",
    label: "Under EPF Office",
    placeholder: "Type Here...",
    type: "text",
    fullWidth: true,

    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeString(value)),150);
       return value;
     }
      
      }

  },
  epfOrganizationOffice: {
    name: "epfOrganizationOffice",
    fullWidth: true,
    // required: true,
   
    label:"Under EPF Office",
    placeholder:"Type Here...",
    type:"text",
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeString(value)),150);
       return value;
     }
      
      }
  },
  epfOrganizationAddress: {
    name: "epfOrganizationAddress",

    type: "text",
    fullWidth: true,
    // required: true,
 
    label:"Address",
    placeholder:"Type Here...",
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeString(value)),150);
       return value;
     }
      
      }
   
  },
  epfOrganizationCity: {
    name: "epfOrganizationCity",
    label: "City",
    placeholder: "Select Here...",
 
    fullWidth: true,
    // required: true,
   

    type: "text",
 
   
 
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText(removeMultipleSpace(safeString(value)),150);
       return value;
     }
      
      }

  },
  epfOrganizationState: {
    name: "epfOrganizationState",
    label: "State",
    placeholder: "Select Here...",
    type: "select",
    fullWidth: true,
    // required: true,
    options: [
      { id: 1, name: "West Bengal" },
      { id: 2, name: "Bihar" },
    ],
  },
  epfOrganizationCountry: {
    name: "epfOrganizationCountry",
    label: "Country",
    placeholder: "Select Here...",
    type: "select",
    fullWidth: true,
    // required: true,
    options: [
      { id: 1, name: "India" },
      { id: "usa", name: "USA" },
    ],
    disabled:true
  },
  epfOrganizationPinCode: {
    name: "epfOrganizationPinCode",
    label: "PIN Code",
    placeholder: "Type Here...",
    type: "number",
    fullWidth: true,
    // required: true,
    customOptions: {
      formatValueFn: (value) => sliceText(parseOnlyNumericValue(safeString(value)), 6),
    },
  },
  epfOrganizationLocation: {
    name: "epfOrganizationLocation",
    label: "Location",
    placeholder: "Type Here...",
    type: "text",
    fullWidth: true,
    // required: true,
    customOptions: {
      formatValueFn: (value) => sliceText(removeMultipleSpace(safeString(value)), 150),
    },
  },
  "epfOrganizationMaster1": {
    name: "epfOrganizationMaster1",
    // label: "Include employer’s EDLI contribution in the CTC",
    type: "checkbox",
   color:"primary",
   
  },
  "epfOrganizationMaster2": {
    name: "epfOrganizationMaster2",
    label: "Include admin charges & employer's EDLI contribution in the CTC",
    type: "checkbox",
   color:"primary"
  },
  "epfOrganizationMaster3": {
    name: "epfOrganizationMaster3",
    label: "Include admin charges in the CTC",
    type: "checkbox",
   color:"primary"
  },
  "epfOrganizationMaster4": {
    name: "epfOrganizationMaster4",
    // label: "Include employer’s EDLI contribution in the CTC",
    type: "checkbox",
   color:"primary"
  },



};

  

  

  export const EPF_API={
    EPF_CREATE:{URL:"/organization-statutory/organization-epf/", METHOD:"POST"},
    EPF_UPDATE:{URL:"/organization-statutory/organization-epf/", METHOD:"PATCH"},
    EPF_DELETE:{URL:"/organization-statutory/organization-epf/", METHOD:"DELETE"},
    EPF_LIST:{URL:"/organization-statutory/organization-epf/", METHOD:"GET"},
    MASTER_EPF_LIST:{URL:"/organization-statutory/organization-epf/admin/master", METHOD:"GET"},
    
  };